<template>
  <div>
    <div
      v-if="change < 0"
      class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0"
    >
      <svg
        class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="sr-only">Decreased by</span>
      {{ change }}%
    </div>
    <div
      v-else-if="change > 0 & change !== Infinity"
      class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0"
    >
      <svg
        class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z"
          clip-rule="evenodd"
        />
      </svg>
      <span class="sr-only">
        Increased by
      </span>
      {{ change }}%
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncreaseDecreaseLabels',
  props: {
    previous: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
  },
  computed: {
    change() {
      return Math.round(((this.current - this.previous) / this.previous) * 100);
    },
  },
};
</script>
